import { geoService } from '@/services'
import { action, createRequestTypes } from '@/utils/actions.utils'

export const FETCH_COUNTRIES = createRequestTypes('FETCH_COUNTRIES')
const fetchCountries = ({ lang, catalogId, simple }) => {
	return async (dispatch) => {
		try {
			await dispatch(request())

			const res = await geoService.fetchCountries({ lang, catalogId, simple })
			return dispatch(success(res.data))
		} catch (err) {
			return dispatch(failure(err))
		}
	}

	function request() {
		return action(FETCH_COUNTRIES.REQUEST)
	}
	function success(payload) {
		return action(FETCH_COUNTRIES.SUCCESS, payload)
	}
	function failure(err) {
		return action(FETCH_COUNTRIES.FAILURE, null, err)
	}
}

export const SELECT_COUNTRY = 'SELECT_COUNTRY'
const selectCountry = (country) => {
	return action(SELECT_COUNTRY, country)
}

export const FETCH_LEVEL2_ENTITIES = createRequestTypes('FETCH_LEVEL2_ENTITIES')
const fetchLevel2Entities = ({ countryGeonameId, level2Typology, searchTerm, lang }) => {
	return async (dispatch) => {
		try {
			await dispatch(request({ countryGeonameId, level2Typology, searchTerm, lang }))

			const res = await geoService.fetchLevel2Entities({
				countryGeonameId,
				level2Typology,
				searchTerm,
				lang
			})
			return dispatch(
				success({
					countryGeonameId,
					entities: res.data.entities,
					searchTerm
				})
			)
		} catch (err) {
			return dispatch(failure(err))
		}
	}

	function request() {
		return action(FETCH_LEVEL2_ENTITIES.REQUEST)
	}
	function success(payload) {
		return action(FETCH_LEVEL2_ENTITIES.SUCCESS, payload)
	}
	function failure(err) {
		return action(FETCH_LEVEL2_ENTITIES.FAILURE, null, err)
	}
}

export const SELECT_LEVEL_2 = 'SELECT_LEVEL_2'
const selectLevel2 = (entity) => {
	return action(SELECT_LEVEL_2, entity)
}

export const EMPTY_LEVEL2_ENTITIES = 'EMPTY_LEVEL2_ENTITIES'
const emptyLevel2Entities = () => {
	return action(EMPTY_LEVEL2_ENTITIES)
}

export const FETCH_LEVEL3_ENTITIES = createRequestTypes('FETCH_LEVEL3_ENTITIES')
const fetchLevel3Entities = ({
	countryGeonameId,
	level2Typology,
	level2GeonameId,
	level3Typology,
	searchTerm,
	lang
}) => {
	return async (dispatch) => {
		try {
			await dispatch(request())

			const res = await geoService.fetchCountries({
				countryGeonameId,
				level2Typology,
				level2GeonameId,
				level3Typology,
				searchTerm,
				lang
			})
			dispatch(
				success({
					level2GeonameId,
					entities: res.data
				})
			)
		} catch (err) {
			dispatch(failure(err))
		}
	}

	function request() {
		return action(FETCH_LEVEL3_ENTITIES.REQUEST)
	}
	function success(payload) {
		return action(FETCH_LEVEL3_ENTITIES.SUCCESS, payload)
	}
	function failure(error) {
		return action(FETCH_LEVEL3_ENTITIES.FAILURE, error)
	}
}

export const SELECT_LEVEL_3 = 'SELECT_LEVEL_3'
const selectLevel3 = (entity) => {
	return action(SELECT_LEVEL_3, entity)
}

export const EMPTY_LEVEL3_ENTITIES = 'EMPTY_LEVEL3_ENTITIES'
const emptyLevel3Entities = () => {
	return action(EMPTY_LEVEL3_ENTITIES)
}

export default {
	fetchCountries,
	selectCountry,
	fetchLevel2Entities,
	selectLevel2,
	emptyLevel2Entities,
	fetchLevel3Entities,
	selectLevel3,
	emptyLevel3Entities
}
